import { render } from "./UserListItemUserInvite.vue?vue&type=template&id=deb45e5a&scoped=true"
import script from "./UserListItemUserInvite.vue?vue&type=script&lang=js"
export * from "./UserListItemUserInvite.vue?vue&type=script&lang=js"

import "./UserListItemUserInvite.vue?vue&type=style&index=0&id=deb45e5a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb45e5a"]])

export default __exports__